import React, {useEffect} from "react"
import { useNavigate } from "react-router-dom"

import "./WebTest.css"
import {retrieveData, sendRequest} from "../../common";

function WebTestGuide() {
	const navigate = useNavigate()

	const resetAnswers = (applyTestId) => {
		sendRequest(`test/reset-apply-test/${applyTestId}/`, 'POST', {}, data => {
			console.log('success')
		})
	}

	return (
		<>
			<div className="webContainer">
				<section className="webTestGuide">
					<h2>검사 시작 전 안내</h2>
					<p>
						본 검사는 지금 현재 자신의 행동경향에 대해 탐색할 수 있는 검사로<br />
						판단, 진단 등을 내리는 것이 아닌 심리적 특성을 탐색합니다.<br />
						<br />
						검사 시행시엔 비교적 편안하고 안정된 상태에서 시행해주시길 바랍니다.
					</p>
					<div className="buttonWrap">
						<button
							className="submitBtn"
							type="submit"
							onClick={() => {
								retrieveData('applyTest').then(applyTest => {
									resetAnswers(applyTest?.id)
								})
								navigate("/conduct-test")
							}}>
							위 내용을 확인하고 시행합니다
						</button>
					</div>
				</section>
			</div>
		</>
	)
}

export default WebTestGuide
